import type { DimensionValue } from "../../store/dimension.value";

export enum DateType {
    DIMENSION_ID = "DIMENSION_ID",
    ABSOLUTE = "ABSOLUTE",
    RELATIVE = "RELATIVE",
}

export interface DimensionIdDateOption {
    type: DateType.DIMENSION_ID;
    id: string;
}

export interface AbsoluteDateOption {
    type: DateType.ABSOLUTE;
    dateString: string;
}

export interface RelativeDateOption {
    type: DateType.RELATIVE;
    daysRelatativeToToday: number;
}

export type DateOption =
    | DimensionIdDateOption
    | AbsoluteDateOption
    | RelativeDateOption;

export const getDimensionIdDate = (
    getDimensionData: (dimension: string) => DimensionValue,
    id: string,
): Date => {
    return new Date(getDimensionData(id).value);
};

export const getAbsoluteDate = (dateString: string): Date => {
    return new Date(dateString);
};

export const getRelativeDate = (daysRelatativeToToday: number): Date => {
    const relativeDate = new Date();
    relativeDate.setDate(relativeDate.getDate() + daysRelatativeToToday);
    return relativeDate;
};
